export default __webpack_public_path__ + "static/media/plus-circle-alt.49c1f2b7.svg";